import { atom, selector } from 'recoil';
import { createQuerySelector } from '../utils/createQuerySelector';
import { persistAtom } from '../utils/persistAtom';
import { AccountQuery, AccountDocument } from './graphql';

export const profileIdState = atom<number | undefined>({
	key: 'account_profileId',
	default: undefined,
	effects_UNSTABLE: [persistAtom]
});

export const authenticatedState = selector<boolean>({
	key: 'account_authenticated',
	get({ get }) {
		const profileId = get(profileIdState);
		return profileId !== undefined;
	}
});

// scrap
export const accountQueryState = createQuerySelector<AccountQuery>(
	'accountQuery',
	AccountDocument
);
